import {
  instance as axios,
  setJwtToken,
} from "../../config/axiosInstance";

// ─── Offer Variant APIs ─────────────────────────────────────────────

export const fetchOfferVariantList = async (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return await axios.get(`/admin/offer-engine/offer-variant/list?${qs}`, setJwtToken());
};

export const createOfferVariant = async (data) => {
  return await axios.post("/admin/offer-engine/offer-variant", data, setJwtToken());
};

export const updateOfferVariant = async (data) => {
  return await axios.put("/admin/offer-engine/offer-variant", data, setJwtToken());
};

// ─── Offer Rule APIs ────────────────────────────────────────────────

export const fetchOfferRuleList = async (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return await axios.get(`/admin/offer-engine/offer-rule/list?${qs}`, setJwtToken());
};

export const createOfferRule = async (data) => {
  return await axios.post("/admin/offer-engine/offer-rule", data, setJwtToken());
};

export const updateOfferRule = async (data) => {
  return await axios.put("/admin/offer-engine/offer-rule", data, setJwtToken());
};
